import { useRouter } from 'next/router';
import { useState } from 'react';
import { useAuth } from './useAuth';
import { sendGTMEvent } from '../services/analytics';

interface Payload {
  shouldRedirectOnSuccess: boolean;
}

export const useGoogleLogin = ({ shouldRedirectOnSuccess }: Payload) => {
  const [isLoading, setIsLoading] = useState(false);

  const { push } = useRouter();
  const { login, auth } = useAuth();

  const handleGoogleLoginSuccess = async () => {
    setIsLoading(true);
    try {
      const isSuccess = await login();
      if (isSuccess && shouldRedirectOnSuccess) {
        if (localStorage.getItem('nud') !== '1') {
          sendGTMEvent('signup', { method: 'google' });
          localStorage.setItem('nud', '1');
        }
        // setUserData(userData);
        // push('/dashboard');
        push('/text-to-image');
      } else {
        // TODO:
      }
    } catch (error) {
      // TODO:
    }
    setIsLoading(false);
  };

  const handleOnError = () => {
    // TODO:
  };

  return { isLoading, handleGoogleLoginSuccess, handleOnError, isLoggedIn: auth.isAuthenticated };
};
